/* eslint-disable */
import type { CallContext, CallOptions } from "nice-grpc-common";
import * as _m0 from "protobufjs/minimal";
import { StringValue } from "./google/protobuf/wrappers";
import { TransactionsResponseWithMetadata } from "./transaction";
import { ChainId, chainIdFromJSON, chainIdToJSON, DfnsTygrisSecrets } from "./util";
import Long = require("long");

export const protobufPackage = "bridge";

export enum BridgeId {
  WORMHOLE = 0,
  UNRECOGNIZED = -1,
}

export function bridgeIdFromJSON(object: any): BridgeId {
  switch (object) {
    case 0:
    case "WORMHOLE":
      return BridgeId.WORMHOLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BridgeId.UNRECOGNIZED;
  }
}

export function bridgeIdToJSON(object: BridgeId): string {
  switch (object) {
    case BridgeId.WORMHOLE:
      return "WORMHOLE";
    case BridgeId.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface EvmAssetInfo {
  tokenId: string;
  contract: string;
}

export interface SolAssetInfo {
  mint: string;
}

export interface AssetInfo {
  evmAssetInfo?: EvmAssetInfo | undefined;
  solAssetInfo?: SolAssetInfo | undefined;
}

export interface BridgeAssetData {
  transactionGroupIdentifier: string;
  sourceAssetInfo: AssetInfo | undefined;
  amount: number;
  bridgerWallet: string;
  sourceChain: ChainId;
  recipientChain: ChainId;
  bridgerRecipientWallet: string;
  bridgeId: BridgeId;
  userOrganization: string;
}

export interface StartBridgeAssetMessage {
  assetInfo: AssetInfo | undefined;
  sourceChain: ChainId;
  recipientChain: ChainId;
  bridgerRecipientWallet: string;
  bridgerWallet: string;
  amount: number;
  bridgeId: BridgeId;
  dfnsSecrets?: DfnsTygrisSecrets | undefined;
  userOrganization: string;
  nativeTransactionHash: string | undefined;
  messageIdentifier: string;
}

export interface TransactionLog {
  blockNumber: string;
  blockHash: string;
  transactionIndex: string;
  removed: boolean;
  address: string;
  data: string;
  topics: string[];
  transactionHash: string;
  logIndex: string;
}

export interface TransactionSignatureWithLogs {
  transaction: string;
  /** A vector of logs, empty if solana */
  logs: TransactionLog[];
}

export interface CompleteBridgeAssetMessage {
  bridgeAssetData: BridgeAssetData | undefined;
  transactionSignatureWithLogs: TransactionSignatureWithLogs | undefined;
  dfnsSecrets?: DfnsTygrisSecrets | undefined;
  messageIdentifier: string;
}

export interface StartBridgeAssetMessages {
  messages: StartBridgeAssetMessage[];
}

export interface CompleteBridgeAssetMessages {
  messages: CompleteBridgeAssetMessage[];
}

function createBaseEvmAssetInfo(): EvmAssetInfo {
  return { tokenId: "", contract: "" };
}

export const EvmAssetInfo = {
  encode(message: EvmAssetInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tokenId !== "") {
      writer.uint32(10).string(message.tokenId);
    }
    if (message.contract !== "") {
      writer.uint32(18).string(message.contract);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EvmAssetInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvmAssetInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tokenId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.contract = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EvmAssetInfo {
    return {
      tokenId: isSet(object.tokenId) ? globalThis.String(object.tokenId) : "",
      contract: isSet(object.contract) ? globalThis.String(object.contract) : "",
    };
  },

  toJSON(message: EvmAssetInfo): unknown {
    const obj: any = {};
    if (message.tokenId !== "") {
      obj.tokenId = message.tokenId;
    }
    if (message.contract !== "") {
      obj.contract = message.contract;
    }
    return obj;
  },

  create(base?: DeepPartial<EvmAssetInfo>): EvmAssetInfo {
    return EvmAssetInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EvmAssetInfo>): EvmAssetInfo {
    const message = createBaseEvmAssetInfo();
    message.tokenId = object.tokenId ?? "";
    message.contract = object.contract ?? "";
    return message;
  },
};

function createBaseSolAssetInfo(): SolAssetInfo {
  return { mint: "" };
}

export const SolAssetInfo = {
  encode(message: SolAssetInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.mint !== "") {
      writer.uint32(10).string(message.mint);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SolAssetInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSolAssetInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.mint = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SolAssetInfo {
    return { mint: isSet(object.mint) ? globalThis.String(object.mint) : "" };
  },

  toJSON(message: SolAssetInfo): unknown {
    const obj: any = {};
    if (message.mint !== "") {
      obj.mint = message.mint;
    }
    return obj;
  },

  create(base?: DeepPartial<SolAssetInfo>): SolAssetInfo {
    return SolAssetInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SolAssetInfo>): SolAssetInfo {
    const message = createBaseSolAssetInfo();
    message.mint = object.mint ?? "";
    return message;
  },
};

function createBaseAssetInfo(): AssetInfo {
  return { evmAssetInfo: undefined, solAssetInfo: undefined };
}

export const AssetInfo = {
  encode(message: AssetInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.evmAssetInfo !== undefined) {
      EvmAssetInfo.encode(message.evmAssetInfo, writer.uint32(10).fork()).ldelim();
    }
    if (message.solAssetInfo !== undefined) {
      SolAssetInfo.encode(message.solAssetInfo, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AssetInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssetInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.evmAssetInfo = EvmAssetInfo.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.solAssetInfo = SolAssetInfo.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssetInfo {
    return {
      evmAssetInfo: isSet(object.evmAssetInfo) ? EvmAssetInfo.fromJSON(object.evmAssetInfo) : undefined,
      solAssetInfo: isSet(object.solAssetInfo) ? SolAssetInfo.fromJSON(object.solAssetInfo) : undefined,
    };
  },

  toJSON(message: AssetInfo): unknown {
    const obj: any = {};
    if (message.evmAssetInfo !== undefined) {
      obj.evmAssetInfo = EvmAssetInfo.toJSON(message.evmAssetInfo);
    }
    if (message.solAssetInfo !== undefined) {
      obj.solAssetInfo = SolAssetInfo.toJSON(message.solAssetInfo);
    }
    return obj;
  },

  create(base?: DeepPartial<AssetInfo>): AssetInfo {
    return AssetInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AssetInfo>): AssetInfo {
    const message = createBaseAssetInfo();
    message.evmAssetInfo = (object.evmAssetInfo !== undefined && object.evmAssetInfo !== null)
      ? EvmAssetInfo.fromPartial(object.evmAssetInfo)
      : undefined;
    message.solAssetInfo = (object.solAssetInfo !== undefined && object.solAssetInfo !== null)
      ? SolAssetInfo.fromPartial(object.solAssetInfo)
      : undefined;
    return message;
  },
};

function createBaseBridgeAssetData(): BridgeAssetData {
  return {
    transactionGroupIdentifier: "",
    sourceAssetInfo: undefined,
    amount: 0,
    bridgerWallet: "",
    sourceChain: 0,
    recipientChain: 0,
    bridgerRecipientWallet: "",
    bridgeId: 0,
    userOrganization: "",
  };
}

export const BridgeAssetData = {
  encode(message: BridgeAssetData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.transactionGroupIdentifier !== "") {
      writer.uint32(10).string(message.transactionGroupIdentifier);
    }
    if (message.sourceAssetInfo !== undefined) {
      AssetInfo.encode(message.sourceAssetInfo, writer.uint32(18).fork()).ldelim();
    }
    if (message.amount !== 0) {
      writer.uint32(24).uint64(message.amount);
    }
    if (message.bridgerWallet !== "") {
      writer.uint32(34).string(message.bridgerWallet);
    }
    if (message.sourceChain !== 0) {
      writer.uint32(40).int32(message.sourceChain);
    }
    if (message.recipientChain !== 0) {
      writer.uint32(48).int32(message.recipientChain);
    }
    if (message.bridgerRecipientWallet !== "") {
      writer.uint32(58).string(message.bridgerRecipientWallet);
    }
    if (message.bridgeId !== 0) {
      writer.uint32(64).int32(message.bridgeId);
    }
    if (message.userOrganization !== "") {
      writer.uint32(74).string(message.userOrganization);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BridgeAssetData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBridgeAssetData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.transactionGroupIdentifier = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.sourceAssetInfo = AssetInfo.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.amount = longToNumber(reader.uint64() as Long);
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.bridgerWallet = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.sourceChain = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.recipientChain = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.bridgerRecipientWallet = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.bridgeId = reader.int32() as any;
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.userOrganization = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BridgeAssetData {
    return {
      transactionGroupIdentifier: isSet(object.transactionGroupIdentifier)
        ? globalThis.String(object.transactionGroupIdentifier)
        : "",
      sourceAssetInfo: isSet(object.sourceAssetInfo) ? AssetInfo.fromJSON(object.sourceAssetInfo) : undefined,
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      bridgerWallet: isSet(object.bridgerWallet) ? globalThis.String(object.bridgerWallet) : "",
      sourceChain: isSet(object.sourceChain) ? chainIdFromJSON(object.sourceChain) : 0,
      recipientChain: isSet(object.recipientChain) ? chainIdFromJSON(object.recipientChain) : 0,
      bridgerRecipientWallet: isSet(object.bridgerRecipientWallet)
        ? globalThis.String(object.bridgerRecipientWallet)
        : "",
      bridgeId: isSet(object.bridgeId) ? bridgeIdFromJSON(object.bridgeId) : 0,
      userOrganization: isSet(object.userOrganization) ? globalThis.String(object.userOrganization) : "",
    };
  },

  toJSON(message: BridgeAssetData): unknown {
    const obj: any = {};
    if (message.transactionGroupIdentifier !== "") {
      obj.transactionGroupIdentifier = message.transactionGroupIdentifier;
    }
    if (message.sourceAssetInfo !== undefined) {
      obj.sourceAssetInfo = AssetInfo.toJSON(message.sourceAssetInfo);
    }
    if (message.amount !== 0) {
      obj.amount = Math.round(message.amount);
    }
    if (message.bridgerWallet !== "") {
      obj.bridgerWallet = message.bridgerWallet;
    }
    if (message.sourceChain !== 0) {
      obj.sourceChain = chainIdToJSON(message.sourceChain);
    }
    if (message.recipientChain !== 0) {
      obj.recipientChain = chainIdToJSON(message.recipientChain);
    }
    if (message.bridgerRecipientWallet !== "") {
      obj.bridgerRecipientWallet = message.bridgerRecipientWallet;
    }
    if (message.bridgeId !== 0) {
      obj.bridgeId = bridgeIdToJSON(message.bridgeId);
    }
    if (message.userOrganization !== "") {
      obj.userOrganization = message.userOrganization;
    }
    return obj;
  },

  create(base?: DeepPartial<BridgeAssetData>): BridgeAssetData {
    return BridgeAssetData.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BridgeAssetData>): BridgeAssetData {
    const message = createBaseBridgeAssetData();
    message.transactionGroupIdentifier = object.transactionGroupIdentifier ?? "";
    message.sourceAssetInfo = (object.sourceAssetInfo !== undefined && object.sourceAssetInfo !== null)
      ? AssetInfo.fromPartial(object.sourceAssetInfo)
      : undefined;
    message.amount = object.amount ?? 0;
    message.bridgerWallet = object.bridgerWallet ?? "";
    message.sourceChain = object.sourceChain ?? 0;
    message.recipientChain = object.recipientChain ?? 0;
    message.bridgerRecipientWallet = object.bridgerRecipientWallet ?? "";
    message.bridgeId = object.bridgeId ?? 0;
    message.userOrganization = object.userOrganization ?? "";
    return message;
  },
};

function createBaseStartBridgeAssetMessage(): StartBridgeAssetMessage {
  return {
    assetInfo: undefined,
    sourceChain: 0,
    recipientChain: 0,
    bridgerRecipientWallet: "",
    bridgerWallet: "",
    amount: 0,
    bridgeId: 0,
    dfnsSecrets: undefined,
    userOrganization: "",
    nativeTransactionHash: undefined,
    messageIdentifier: "",
  };
}

export const StartBridgeAssetMessage = {
  encode(message: StartBridgeAssetMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.assetInfo !== undefined) {
      AssetInfo.encode(message.assetInfo, writer.uint32(10).fork()).ldelim();
    }
    if (message.sourceChain !== 0) {
      writer.uint32(16).int32(message.sourceChain);
    }
    if (message.recipientChain !== 0) {
      writer.uint32(24).int32(message.recipientChain);
    }
    if (message.bridgerRecipientWallet !== "") {
      writer.uint32(34).string(message.bridgerRecipientWallet);
    }
    if (message.bridgerWallet !== "") {
      writer.uint32(42).string(message.bridgerWallet);
    }
    if (message.amount !== 0) {
      writer.uint32(48).uint64(message.amount);
    }
    if (message.bridgeId !== 0) {
      writer.uint32(56).int32(message.bridgeId);
    }
    if (message.dfnsSecrets !== undefined) {
      DfnsTygrisSecrets.encode(message.dfnsSecrets, writer.uint32(66).fork()).ldelim();
    }
    if (message.userOrganization !== "") {
      writer.uint32(74).string(message.userOrganization);
    }
    if (message.nativeTransactionHash !== undefined) {
      StringValue.encode({ value: message.nativeTransactionHash! }, writer.uint32(82).fork()).ldelim();
    }
    if (message.messageIdentifier !== "") {
      writer.uint32(90).string(message.messageIdentifier);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StartBridgeAssetMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartBridgeAssetMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.assetInfo = AssetInfo.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.sourceChain = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.recipientChain = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.bridgerRecipientWallet = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.bridgerWallet = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.amount = longToNumber(reader.uint64() as Long);
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.bridgeId = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.dfnsSecrets = DfnsTygrisSecrets.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.userOrganization = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.nativeTransactionHash = StringValue.decode(reader, reader.uint32()).value;
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.messageIdentifier = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartBridgeAssetMessage {
    return {
      assetInfo: isSet(object.assetInfo) ? AssetInfo.fromJSON(object.assetInfo) : undefined,
      sourceChain: isSet(object.sourceChain) ? chainIdFromJSON(object.sourceChain) : 0,
      recipientChain: isSet(object.recipientChain) ? chainIdFromJSON(object.recipientChain) : 0,
      bridgerRecipientWallet: isSet(object.bridgerRecipientWallet)
        ? globalThis.String(object.bridgerRecipientWallet)
        : "",
      bridgerWallet: isSet(object.bridgerWallet) ? globalThis.String(object.bridgerWallet) : "",
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      bridgeId: isSet(object.bridgeId) ? bridgeIdFromJSON(object.bridgeId) : 0,
      dfnsSecrets: isSet(object.dfnsSecrets) ? DfnsTygrisSecrets.fromJSON(object.dfnsSecrets) : undefined,
      userOrganization: isSet(object.userOrganization) ? globalThis.String(object.userOrganization) : "",
      nativeTransactionHash: isSet(object.nativeTransactionHash) ? String(object.nativeTransactionHash) : undefined,
      messageIdentifier: isSet(object.messageIdentifier) ? globalThis.String(object.messageIdentifier) : "",
    };
  },

  toJSON(message: StartBridgeAssetMessage): unknown {
    const obj: any = {};
    if (message.assetInfo !== undefined) {
      obj.assetInfo = AssetInfo.toJSON(message.assetInfo);
    }
    if (message.sourceChain !== 0) {
      obj.sourceChain = chainIdToJSON(message.sourceChain);
    }
    if (message.recipientChain !== 0) {
      obj.recipientChain = chainIdToJSON(message.recipientChain);
    }
    if (message.bridgerRecipientWallet !== "") {
      obj.bridgerRecipientWallet = message.bridgerRecipientWallet;
    }
    if (message.bridgerWallet !== "") {
      obj.bridgerWallet = message.bridgerWallet;
    }
    if (message.amount !== 0) {
      obj.amount = Math.round(message.amount);
    }
    if (message.bridgeId !== 0) {
      obj.bridgeId = bridgeIdToJSON(message.bridgeId);
    }
    if (message.dfnsSecrets !== undefined) {
      obj.dfnsSecrets = DfnsTygrisSecrets.toJSON(message.dfnsSecrets);
    }
    if (message.userOrganization !== "") {
      obj.userOrganization = message.userOrganization;
    }
    if (message.nativeTransactionHash !== undefined) {
      obj.nativeTransactionHash = message.nativeTransactionHash;
    }
    if (message.messageIdentifier !== "") {
      obj.messageIdentifier = message.messageIdentifier;
    }
    return obj;
  },

  create(base?: DeepPartial<StartBridgeAssetMessage>): StartBridgeAssetMessage {
    return StartBridgeAssetMessage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartBridgeAssetMessage>): StartBridgeAssetMessage {
    const message = createBaseStartBridgeAssetMessage();
    message.assetInfo = (object.assetInfo !== undefined && object.assetInfo !== null)
      ? AssetInfo.fromPartial(object.assetInfo)
      : undefined;
    message.sourceChain = object.sourceChain ?? 0;
    message.recipientChain = object.recipientChain ?? 0;
    message.bridgerRecipientWallet = object.bridgerRecipientWallet ?? "";
    message.bridgerWallet = object.bridgerWallet ?? "";
    message.amount = object.amount ?? 0;
    message.bridgeId = object.bridgeId ?? 0;
    message.dfnsSecrets = (object.dfnsSecrets !== undefined && object.dfnsSecrets !== null)
      ? DfnsTygrisSecrets.fromPartial(object.dfnsSecrets)
      : undefined;
    message.userOrganization = object.userOrganization ?? "";
    message.nativeTransactionHash = object.nativeTransactionHash ?? undefined;
    message.messageIdentifier = object.messageIdentifier ?? "";
    return message;
  },
};

function createBaseTransactionLog(): TransactionLog {
  return {
    blockNumber: "",
    blockHash: "",
    transactionIndex: "",
    removed: false,
    address: "",
    data: "",
    topics: [],
    transactionHash: "",
    logIndex: "",
  };
}

export const TransactionLog = {
  encode(message: TransactionLog, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.blockNumber !== "") {
      writer.uint32(10).string(message.blockNumber);
    }
    if (message.blockHash !== "") {
      writer.uint32(18).string(message.blockHash);
    }
    if (message.transactionIndex !== "") {
      writer.uint32(26).string(message.transactionIndex);
    }
    if (message.removed === true) {
      writer.uint32(32).bool(message.removed);
    }
    if (message.address !== "") {
      writer.uint32(42).string(message.address);
    }
    if (message.data !== "") {
      writer.uint32(50).string(message.data);
    }
    for (const v of message.topics) {
      writer.uint32(58).string(v!);
    }
    if (message.transactionHash !== "") {
      writer.uint32(66).string(message.transactionHash);
    }
    if (message.logIndex !== "") {
      writer.uint32(74).string(message.logIndex);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TransactionLog {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransactionLog();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.blockNumber = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.blockHash = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.transactionIndex = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.removed = reader.bool();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.address = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.data = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.topics.push(reader.string());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.transactionHash = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.logIndex = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransactionLog {
    return {
      blockNumber: isSet(object.blockNumber) ? globalThis.String(object.blockNumber) : "",
      blockHash: isSet(object.blockHash) ? globalThis.String(object.blockHash) : "",
      transactionIndex: isSet(object.transactionIndex) ? globalThis.String(object.transactionIndex) : "",
      removed: isSet(object.removed) ? globalThis.Boolean(object.removed) : false,
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      data: isSet(object.data) ? globalThis.String(object.data) : "",
      topics: globalThis.Array.isArray(object?.topics) ? object.topics.map((e: any) => globalThis.String(e)) : [],
      transactionHash: isSet(object.transactionHash) ? globalThis.String(object.transactionHash) : "",
      logIndex: isSet(object.logIndex) ? globalThis.String(object.logIndex) : "",
    };
  },

  toJSON(message: TransactionLog): unknown {
    const obj: any = {};
    if (message.blockNumber !== "") {
      obj.blockNumber = message.blockNumber;
    }
    if (message.blockHash !== "") {
      obj.blockHash = message.blockHash;
    }
    if (message.transactionIndex !== "") {
      obj.transactionIndex = message.transactionIndex;
    }
    if (message.removed === true) {
      obj.removed = message.removed;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.data !== "") {
      obj.data = message.data;
    }
    if (message.topics?.length) {
      obj.topics = message.topics;
    }
    if (message.transactionHash !== "") {
      obj.transactionHash = message.transactionHash;
    }
    if (message.logIndex !== "") {
      obj.logIndex = message.logIndex;
    }
    return obj;
  },

  create(base?: DeepPartial<TransactionLog>): TransactionLog {
    return TransactionLog.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TransactionLog>): TransactionLog {
    const message = createBaseTransactionLog();
    message.blockNumber = object.blockNumber ?? "";
    message.blockHash = object.blockHash ?? "";
    message.transactionIndex = object.transactionIndex ?? "";
    message.removed = object.removed ?? false;
    message.address = object.address ?? "";
    message.data = object.data ?? "";
    message.topics = object.topics?.map((e) => e) || [];
    message.transactionHash = object.transactionHash ?? "";
    message.logIndex = object.logIndex ?? "";
    return message;
  },
};

function createBaseTransactionSignatureWithLogs(): TransactionSignatureWithLogs {
  return { transaction: "", logs: [] };
}

export const TransactionSignatureWithLogs = {
  encode(message: TransactionSignatureWithLogs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.transaction !== "") {
      writer.uint32(10).string(message.transaction);
    }
    for (const v of message.logs) {
      TransactionLog.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TransactionSignatureWithLogs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransactionSignatureWithLogs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.transaction = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.logs.push(TransactionLog.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransactionSignatureWithLogs {
    return {
      transaction: isSet(object.transaction) ? globalThis.String(object.transaction) : "",
      logs: globalThis.Array.isArray(object?.logs) ? object.logs.map((e: any) => TransactionLog.fromJSON(e)) : [],
    };
  },

  toJSON(message: TransactionSignatureWithLogs): unknown {
    const obj: any = {};
    if (message.transaction !== "") {
      obj.transaction = message.transaction;
    }
    if (message.logs?.length) {
      obj.logs = message.logs.map((e) => TransactionLog.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<TransactionSignatureWithLogs>): TransactionSignatureWithLogs {
    return TransactionSignatureWithLogs.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TransactionSignatureWithLogs>): TransactionSignatureWithLogs {
    const message = createBaseTransactionSignatureWithLogs();
    message.transaction = object.transaction ?? "";
    message.logs = object.logs?.map((e) => TransactionLog.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCompleteBridgeAssetMessage(): CompleteBridgeAssetMessage {
  return {
    bridgeAssetData: undefined,
    transactionSignatureWithLogs: undefined,
    dfnsSecrets: undefined,
    messageIdentifier: "",
  };
}

export const CompleteBridgeAssetMessage = {
  encode(message: CompleteBridgeAssetMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.bridgeAssetData !== undefined) {
      BridgeAssetData.encode(message.bridgeAssetData, writer.uint32(10).fork()).ldelim();
    }
    if (message.transactionSignatureWithLogs !== undefined) {
      TransactionSignatureWithLogs.encode(message.transactionSignatureWithLogs, writer.uint32(18).fork()).ldelim();
    }
    if (message.dfnsSecrets !== undefined) {
      DfnsTygrisSecrets.encode(message.dfnsSecrets, writer.uint32(26).fork()).ldelim();
    }
    if (message.messageIdentifier !== "") {
      writer.uint32(34).string(message.messageIdentifier);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CompleteBridgeAssetMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompleteBridgeAssetMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.bridgeAssetData = BridgeAssetData.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.transactionSignatureWithLogs = TransactionSignatureWithLogs.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.dfnsSecrets = DfnsTygrisSecrets.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.messageIdentifier = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompleteBridgeAssetMessage {
    return {
      bridgeAssetData: isSet(object.bridgeAssetData) ? BridgeAssetData.fromJSON(object.bridgeAssetData) : undefined,
      transactionSignatureWithLogs: isSet(object.transactionSignatureWithLogs)
        ? TransactionSignatureWithLogs.fromJSON(object.transactionSignatureWithLogs)
        : undefined,
      dfnsSecrets: isSet(object.dfnsSecrets) ? DfnsTygrisSecrets.fromJSON(object.dfnsSecrets) : undefined,
      messageIdentifier: isSet(object.messageIdentifier) ? globalThis.String(object.messageIdentifier) : "",
    };
  },

  toJSON(message: CompleteBridgeAssetMessage): unknown {
    const obj: any = {};
    if (message.bridgeAssetData !== undefined) {
      obj.bridgeAssetData = BridgeAssetData.toJSON(message.bridgeAssetData);
    }
    if (message.transactionSignatureWithLogs !== undefined) {
      obj.transactionSignatureWithLogs = TransactionSignatureWithLogs.toJSON(message.transactionSignatureWithLogs);
    }
    if (message.dfnsSecrets !== undefined) {
      obj.dfnsSecrets = DfnsTygrisSecrets.toJSON(message.dfnsSecrets);
    }
    if (message.messageIdentifier !== "") {
      obj.messageIdentifier = message.messageIdentifier;
    }
    return obj;
  },

  create(base?: DeepPartial<CompleteBridgeAssetMessage>): CompleteBridgeAssetMessage {
    return CompleteBridgeAssetMessage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompleteBridgeAssetMessage>): CompleteBridgeAssetMessage {
    const message = createBaseCompleteBridgeAssetMessage();
    message.bridgeAssetData = (object.bridgeAssetData !== undefined && object.bridgeAssetData !== null)
      ? BridgeAssetData.fromPartial(object.bridgeAssetData)
      : undefined;
    message.transactionSignatureWithLogs =
      (object.transactionSignatureWithLogs !== undefined && object.transactionSignatureWithLogs !== null)
        ? TransactionSignatureWithLogs.fromPartial(object.transactionSignatureWithLogs)
        : undefined;
    message.dfnsSecrets = (object.dfnsSecrets !== undefined && object.dfnsSecrets !== null)
      ? DfnsTygrisSecrets.fromPartial(object.dfnsSecrets)
      : undefined;
    message.messageIdentifier = object.messageIdentifier ?? "";
    return message;
  },
};

function createBaseStartBridgeAssetMessages(): StartBridgeAssetMessages {
  return { messages: [] };
}

export const StartBridgeAssetMessages = {
  encode(message: StartBridgeAssetMessages, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.messages) {
      StartBridgeAssetMessage.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StartBridgeAssetMessages {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartBridgeAssetMessages();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.messages.push(StartBridgeAssetMessage.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartBridgeAssetMessages {
    return {
      messages: globalThis.Array.isArray(object?.messages)
        ? object.messages.map((e: any) => StartBridgeAssetMessage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: StartBridgeAssetMessages): unknown {
    const obj: any = {};
    if (message.messages?.length) {
      obj.messages = message.messages.map((e) => StartBridgeAssetMessage.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<StartBridgeAssetMessages>): StartBridgeAssetMessages {
    return StartBridgeAssetMessages.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartBridgeAssetMessages>): StartBridgeAssetMessages {
    const message = createBaseStartBridgeAssetMessages();
    message.messages = object.messages?.map((e) => StartBridgeAssetMessage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCompleteBridgeAssetMessages(): CompleteBridgeAssetMessages {
  return { messages: [] };
}

export const CompleteBridgeAssetMessages = {
  encode(message: CompleteBridgeAssetMessages, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.messages) {
      CompleteBridgeAssetMessage.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CompleteBridgeAssetMessages {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompleteBridgeAssetMessages();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.messages.push(CompleteBridgeAssetMessage.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompleteBridgeAssetMessages {
    return {
      messages: globalThis.Array.isArray(object?.messages)
        ? object.messages.map((e: any) => CompleteBridgeAssetMessage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CompleteBridgeAssetMessages): unknown {
    const obj: any = {};
    if (message.messages?.length) {
      obj.messages = message.messages.map((e) => CompleteBridgeAssetMessage.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<CompleteBridgeAssetMessages>): CompleteBridgeAssetMessages {
    return CompleteBridgeAssetMessages.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompleteBridgeAssetMessages>): CompleteBridgeAssetMessages {
    const message = createBaseCompleteBridgeAssetMessages();
    message.messages = object.messages?.map((e) => CompleteBridgeAssetMessage.fromPartial(e)) || [];
    return message;
  },
};

export type BridgeServiceDefinition = typeof BridgeServiceDefinition;
export const BridgeServiceDefinition = {
  name: "BridgeService",
  fullName: "bridge.BridgeService",
  methods: {
    startBridgeAsset: {
      name: "StartBridgeAsset",
      requestType: StartBridgeAssetMessages,
      requestStream: false,
      responseType: TransactionsResponseWithMetadata,
      responseStream: false,
      options: {},
    },
    completeBridgeAsset: {
      name: "CompleteBridgeAsset",
      requestType: CompleteBridgeAssetMessages,
      requestStream: false,
      responseType: TransactionsResponseWithMetadata,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface BridgeServiceImplementation<CallContextExt = {}> {
  startBridgeAsset(
    request: StartBridgeAssetMessages,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<TransactionsResponseWithMetadata>>;
  completeBridgeAsset(
    request: CompleteBridgeAssetMessages,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<TransactionsResponseWithMetadata>>;
}

export interface BridgeServiceClient<CallOptionsExt = {}> {
  startBridgeAsset(
    request: DeepPartial<StartBridgeAssetMessages>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<TransactionsResponseWithMetadata>;
  completeBridgeAsset(
    request: DeepPartial<CompleteBridgeAssetMessages>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<TransactionsResponseWithMetadata>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
